// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__yfXGm","footer":"Footer_footer__Q0Z6t","links":"Footer_links___ZUw0","link":"Footer_link__uhkRB","copy":"Footer_copy__RMyUQ"};